import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "components";
import { icons } from "utils/constants";
import { getDataFromLocalStorage, titleCaseString } from "utils/helpers";
import { getMySubscription, getSubscription } from "store/globalSlice";
import { orderBy } from "lodash";
import UserEditDetailPopup from "components/layouts/UserEditDetailPopup";
import { useNavigate } from "react-router-dom";
import "./Subscription.scss";

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: "#5EB44B",
//       contrastText: common.white,
//     },
//   },
// });

const Subscription = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const reduxData = useSelector((state) => state.global);
  const { isDarkMode } = reduxData || {};
  const { sub_tier_id: subTierId, status } =
    getDataFromLocalStorage("subscription") || {};
  const [subscriptionList, setSubscriptionList] = useState([]);
  const [loading, setLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [subLoading, setSubLoading] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchSubscription = async () => {
    const res = await dispatch(getSubscription());
    setSubscriptionList(orderBy(res?.data || [], "min_usd_per_month"));
    setLoading(false);
  };
  const handleClickOutside = (e) => {
    let element = e?.target?.className;
    if (element === "string" && element.includes("MuiDialog-container")) {
      localStorage.removeItem("unTrnsDetails");
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  });
  useEffect(() => {
    fetchSubscription();
    dispatch(getMySubscription());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      id="subscription-container"
      className={`${isDarkMode ? "custom-scroll-dark" : "custom-scroll"}`}
    >
      {isModalOpen && (
        <UserEditDetailPopup
          onHide={() => setIsModalOpen(false)}
          setIsModalOpen={setIsModalOpen}
        />
      )}
      {loading ? (
        <>
          <div
            className={`${
              isDarkMode ? "skeleton-dark" : "skeleton"
            } h-40 mb-2 br-4`}
          />
          <div
            className={`${isDarkMode ? "skeleton-dark" : "skeleton"} h-22 br-4`}
          />
          <div className="cmt-50 row">
            <div className="col-md-4 h-575 br-20">
              <div
                className={`${isDarkMode ? "skeleton-dark" : "skeleton"} h-100`}
              />
            </div>
            <div className="col-md-4 h-575 br-20">
              <div
                className={`${isDarkMode ? "skeleton-dark" : "skeleton"} h-100`}
              />
            </div>
            <div className="col-md-4 h-575 br-20">
              <div
                className={`${isDarkMode ? "skeleton-dark" : "skeleton"} h-100`}
              />
            </div>
          </div>
          <div
            className={`${
              isDarkMode ? "skeleton-dark" : "skeleton"
            } cmt-30 h-45 mb-2 br-4`}
          />
        </>
      ) : (
        <>
          <div
            className={`text-center text-29-600 ${
              isDarkMode ? "color-ffff" : "color-2749"
            }`}
          >
            Find the best plan for you
          </div>
          <div className="cmt-50 d-flex flex-wrap gap-5">
            {subscriptionList?.map((elm, index) => {
              const {
                name,
                min_fund_per_month,
                description,
                project_limit,
                max_queries_per_day,
                sub_tier_id,
                min_usd_per_month,
              } = elm;
              const isActive = sub_tier_id === subTierId && status === "active";
              return (
                <div
                  key={index}
                  className={`${
                    isDarkMode
                      ? "subscription-block-dark"
                      : "subscription-block"
                  } ${isActive ? "active-sub" : ""}`}
                >
                  <div
                    className={`${
                      isDarkMode ? "active-sub-text-dark" : "active-sub-text"
                    } text-10-600`}
                  >
                    Active
                  </div>
                  <div
                    className={`${isDarkMode ? "" : "cp-20"} ${
                      isDarkMode ? "sub-block-dark" : "sub-block"
                    } ${isDarkMode ? "" : "b-dee3"} `}
                  >
                    <div className={`${isDarkMode ? "dark-card-sub" : ""}`}>
                      <div
                        className={`text-22-400 ${
                          isDarkMode ? "color-c9c9" : "color-7e91"
                        }`}
                      >
                        {titleCaseString(name)}
                      </div>
                      <div
                        className={`text-26-500 ${
                          isDarkMode ? "color-ffff" : "color-2947"
                        }`}
                      >{`${min_fund_per_month.toFixed(2)} FUND/month`}</div>
                      <div
                        className={`text-20-400 ${
                          isDarkMode ? "color-c9c9" : "color-7e91"
                        } text-center`}
                      >
                        ~${min_usd_per_month}
                      </div>
                      <div className="bb-dee3 cmt-20 cmb-20" />
                      <div
                        className={`text-16-400 ${
                          isDarkMode ? "color-c9c9" : "color-7e91"
                        }`}
                      >
                        {description}
                      </div>
                      <div className={`cmt-26 ${isActive ? "h-277" : "h-300"}`}>
                        <div className="d-flex gap-2 mb-2">
                          <span>
                            <img
                              src={isDarkMode ? icons.checkLight : icons.check}
                              alt="check"
                              className="fit-image"
                            />
                          </span>
                          <span
                            className={`text-16-400 ${
                              isDarkMode ? "color-ffff" : "color-2749"
                            }`}
                          >
                            Projects limit{" "}
                            {min_usd_per_month === 700
                              ? "Unlimited"
                              : project_limit}
                          </span>
                        </div>
                        <div className="d-flex gap-2">
                          <span>
                            <img
                              src={isDarkMode ? icons.checkLight : icons.check}
                              alt="check"
                              className="fit-image"
                            />
                          </span>
                          <span
                            className={`text-16-400 ${
                              isDarkMode ? "color-ffff" : "color-2749"
                            }`}
                          >
                            Query limit {max_queries_per_day?.toLocaleString()}
                          </span>
                        </div>
                      </div>
                      <div className="w-100">
                        {/* {isActive ? (
                          <>
                            <div className="bb-dee3 invisible" />
                            <div className="d-flex cpt-20 invisible">
                              <div className="w-50 text-16-400 color-7e91">
                                Pre-paid monthly compute units:
                              </div>
                              <div className="w-50 d-flex justify-content-end text-16-500 color-2749">
                                300 FUND
                              </div>
                            </div>
                          </>
                        ) : */}
                        <Button
                          btnStyle="PD"
                          btnText={
                            isActive ? "Renew Subscription" : "Get started"
                          }
                          className="w-100"
                          loading={subLoading === sub_tier_id}
                          onClick={async () => {
                            navigate(`/subscription-payment/${sub_tier_id}`);
                          }}
                        />
                        {/* } */}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div
            className={`${isDarkMode ? "customTier-dark" : "customTier"} ${
              isDarkMode ? "" : "b-dee3"
            } cmt-20`}
          >
            <div className={`${isDarkMode ? "dark-customTier" : ""}`}>
              <div className="fa-center gap-1 mb-2 ">
                <span
                  className={`text-16-400 ${
                    isDarkMode ? "color-ffff" : "color-2749"
                  }`}
                >
                  Custom Tier
                </span>
              </div>
              <div
                className={`text-16-400 ${
                  isDarkMode ? "color-c9c9" : "color-7e91"
                }`}
              >
                Customize projects and query limits according to your need.
              </div>
            </div>
          </div>
          <div className="fa-center gap-1 cmt-25 mb-2">
            <span
              className={`text-16-400 ${
                isDarkMode ? "color-ffff" : "color-2749"
              }`}
            >
              How to get FUND
            </span>
            <span className="h-20 d-flex">
              <img
                src={isDarkMode ? icons.helpCircleLight : icons.helpCircle}
                alt="helpCircle"
                className="fit-image"
              />
            </span>
          </div>
          <div
            className="text-16-400 hover-effect mb-2"
            onClick={() => {
              window.open(
                "https://www.coingecko.com/en/coins/unification#markets",
                "_blank"
              );
            }}
          >
            https://www.coingecko.com/en/coins/unification#markets
          </div>
          <div
            className="text-16-400 hover-effect"
            onClick={() => {
              window.open("https://unification.com/fund", "_blank");
            }}
          >
            https://unification.com/fund
          </div>
        </>
      )}
    </div>
  );
};

export default Subscription;
